<div class="wb-coupon-wrapper">
  <input
    type="text"
    id="{{config.property}}"
    placeholder="{{config.placeholder || config.label | translate | ucFirst}}"
    [maxLength]="(config.options.enforceFormat ? 7 : 999999999)"
    [value]="value"
    [disabled]="hasValidatedCoupon"
    [ngClass]="hasErrors ? 'error' : ''"
    onkeyup="this.value = this.value.toUpperCase();"
    (change)="onValueChanged($event)" />
    @if (!this.hasValidatedCoupon) {
      <button type="button"
        class="wb-coupon-inline-button"
        (click)="validateCoupon()">
        {{ 'validate' | translate | ucFirst }}
      </button>
    }
    @if (this.hasValidatedCoupon) {
      <img class="wb-coupon-inline-button" src="https://yourwebbooker.com/assets/icon-order-success.svg">
    }
  </div>

  <app-field-error
    [config]="config"
    (validityChanged)="validityChanged($event)">
  </app-field-error>
